<div data-test="8Njh9VWy" class="date-switch" UIKitDropdown>
  <button
    data-test="oj3uibVT"
    (click)="prevYear()"
    class="date-switch__button date-switch__button-prev button button_secondary"
  >
    <i data-test="AAYML_yL" class="material-icons md-16">keyboard_arrow_left</i>
  </button>
  <button data-test="CPq833kE" class="date-switch__text button button_secondary">
    {{ year }}
  </button>
  <button
    data-test="c_JDXG7P"
    (click)="nextYear()"
    class="date-switch__button date-switch__button-next button button_secondary"
  >
    <i data-test="EfvhgVcl" class="material-icons md-16">keyboard_arrow_right</i>
  </button>
</div>
